import type { ReactNode } from 'react';
import cx from 'clsx';

import styles from './index.module.css';

interface Props {
  children: ReactNode;
  hasCtaButton?: boolean;
  hasStickyBar?: boolean;
}

const FloatingWrapper = ({
  children,
  hasCtaButton = false,
  hasStickyBar = false,
}: Props) => {
  return (
    <div
      className={cx([
        styles.wrapper,
        hasCtaButton && styles.hasCta,
        hasStickyBar && styles.hasStickyBar,
      ])}
      id="floatingWrapper"
    >
      {children}
    </div>
  );
};

export default FloatingWrapper;
